module.exports = __webpack_public_path__ + "img/dashboard-24px.svg";